import { useSelector } from 'react-redux';

import { AEMContentProvider, AemFeature, createAemUrl } from '@app/components/AdobeExperienceFragments';
import { selectConfig, selectLocale, selectUserInfo } from '@app/redux';

export const AemAd = () => {
  const { aemBaseUrl } = useSelector(selectConfig);
  const {
    locale: { userLocale },
  } = useSelector(selectLocale);
  const {
    userInfo: { accountType },
  } = useSelector(selectUserInfo);

  return (
    <AEMContentProvider
      src={createAemUrl({
        baseUrl: aemBaseUrl,
        locale: userLocale,
        feature: AemFeature.MV_SHIELD_AD,
        accountType,
      })}
    />
  );
};
